import React from 'react';
import { Tooltip, Typography } from '@mui/material';

export const TooltipWrapper: React.FC<{ text: string }> = ({ text }) => {
  if (!text || text === '-') {
    return <Typography variant="body2" color="text.secondary" align="left">-</Typography>;
  }

  return (
    <Tooltip title={text} arrow placement="top-start">
      <Typography
        variant="body2"
        align="left"
        sx={{
          maxWidth: 220,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontWeight: 500,
          color: 'text.primary',
          textAlign: 'left',
        }}
      >
        {text}
      </Typography>
    </Tooltip>
  );
};

export const unixToCurrentTimezone = (timestamp: number | undefined, fullFormat: boolean = false): string => {
  if (!timestamp) return '-';
  const date = new Date(timestamp * 1000);
  return fullFormat ? date.toLocaleString() : date.toLocaleDateString();
};

export const isLicenseActive = (feature?: {
  startDate: number | string;
  endDate: number | string;
}): boolean => {
  if (!feature) return false;
  return Number(feature.endDate) * 1000 > Date.now();
};

export const checkHasAnyActiveLicense = (subscriptions: Record<string, any> | undefined): boolean => {
  if (!subscriptions) return false;
  return (
    isLicenseActive(subscriptions.hierTalentBase) ||
    isLicenseActive(subscriptions.hierTalentAutoClassify) ||
    isLicenseActive(subscriptions.hierTalentJobPost) ||
    isLicenseActive(subscriptions.hierTalentAutoAssessments) ||
    isLicenseActive(subscriptions.hierTalentSmartInterviews) ||
    isLicenseActive(subscriptions.hierTalentCca) ||
    isLicenseActive(subscriptions.hierTalentCandiBank) ||
    isLicenseActive(subscriptions.hierTalentWellness) ||
    isLicenseActive(subscriptions.hierTalentPsychometricFaxtor)
  );
};
